module.exports = __webpack_public_path__ + "static/media/document_icon.380a33ec.svg";